import { Component, OnInit } from '@angular/core';
import { UserService } from '@services/user/user.service';
import { SessionService } from '@services/session/session.service';
import { OktaAuthService } from '@common_libraries/Services/login/oktaAuth.service';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styles: [],
    standalone: true
})


export class NotFoundComponent implements OnInit {

  countDown: number = 15;

  constructor(private userService: UserService, private sessionService: SessionService, private okta: OktaAuthService,) { }

  ngOnInit() {    
     setInterval(() => {
      
      this.countDown--;
      
      if (this.countDown === 1) {
        this.logout();
      }      
      
    }, 1000);


  }

  logout() {
    this.sessionService.SetIsLoggedIn(false);
    this.okta.logout();
  }

}
